import { StrictLocalizeFunction } from "@faire/web/common/localization";

export const MIN_PASSWORD_LENGTH = 8;

export const somethingWentWrongPleaseTryAgainOrContactUs = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    id: "6Fq8WW",
    defaultMessage: "Something went wrong, please try again or contact us.",
    description: { text: "Notifying users of an error" },
  });

export const ENABLE_CONSUMER_MODE = "enable-consumer-mode";
